module.exports = __webpack_public_path__ + "static/img/91BM-071-Li.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-071-Li.jpg
// module id = uqDa
// module chunks = 0